export default {
  demo: {
    msg: "测试消息",
  },
  common: {
    loadMore: "加载更多",
    btn: {
      reset: "重置",
      submit: "提交",
      cancel: "取消",
    },
    require: "必填",
    success: "提交成功",
  },
  header: {
    home: "首页",
    about: "关于西陇",
    product: "产品中心",
    news: "新闻资讯",
    investor: "投资者关系",
    services: "服务网络",
    search: "文档查询",
    mall: "自营商城",
    aboutList: [
      { name: "企业简介", url: "./about.html", id: 1 },
      { name: "企业里程碑", url: "./history.html", id: 2 },
      { name: "实力影响", url: "./honor.html", id: 3 },
      { name: "加入我们", url: "./join.html", id: 4 },
    ],
    productList: [
      { name: "试剂", url: "./product.html", id: 1 },
      { name: "原料", url: "./material.html", id: 2 },
      { name: "新能源材料", url: "", id: 7 },
      // { name: "日化", url: "./daily.html", id: 3 },
      // {name: "大健康", url: "./health.html", id: 4},
      // {name: "自有品牌", url: "./brand.html", id: 5},
      // {name: "互联网", url: "./internet.html", id: 6},
    ],
    newsList: [
      { name: "集团新闻", url: "./news.html?type=0", id: 1 },
      { name: "产品故事", url: "./material.html", id: 2 },
      { name: "视频中心 ", url: "./daily.html", id: 3 },
      { name: "自有品牌 ", url: "./brand.html", id: 4 },
    ],
    searchList: [
      { name: "COA 查询", url: "./searchCoa.html", id: 1 },
      { name: "MSDS 查询", url: "./searchMsds.html", id: 2 },
      { name: "安全标签 查询", url: "./searchSafetyLabel.html", id: 3 },
      { name: "TDS 查询", url: "./searchTds.html", id: 4 },
    ],
    contactList: [
      { name: "客服：", id: 1 },
      { name: "留言反馈", url: "./contact.html", id: 2 },
    ],
  },
  footer: {
    contact: "联系我们",
    footerList: [
      {
        title: "关于西陇",
        url: "./about.html",
        id: 1,
        list: [
          {
            title: "企业简介",
            url: "./about.html",
            id: "1-1",
          },
          {
            title: "企业里程碑",
            url: "./history.html",
            id: "1-2",
          },
          {
            title: "实力影响",
            url: "./honor.html",
            id: "1-3",
          },
          {
            title: "加入我们",
            url: "./join.html",
            id: "1-4",
          },
        ],
      },
      {
        title: "产品中心",
        url: "./product.html",
        id: 2,
        list: [
          {
            title: "试剂",
            url: "./product.html",
            id: "2-1",
          },
          {
            title: "原料",
            url: "./material.html",
            id: "2-2",
          },
          {
            title: "新能源材料",
            url: "",
            id: "2-6",
          },
          // {
          //   title: "日化",
          //   url: "./daily.html",
          //   id: "2-3",
          // },
          // {
          //   title: "大健康",
          //   url: "./health.html",
          //   id: "2-3",
          // },
          // {
          //   title: "自有品牌",
          //   url: "./brand.html",
          //   id: "2-4",
          // },
          // {
          //   title: "互联网",
          //   url: "./internet.html",
          //   id: "2-5",
          // },
        ],
      },
      {
        title: "投资者关系",
        url: "./gover.html",
        id: 3,
        list: [
          {
            title: "公司治理",
            url: "./gover.html",
            id: "3-1",
          },
          {
            title: "信息披露",
            url: "http://www.cninfo.com.cn/new/disclosure/stock?stockCode=002584&orgId=9900019958#latestAnnouncement",
            id: "3-2",
          },
          {
            title: "定期报告",
            url: "http://www.csrc.gov.cn/",
            id: "3-3",
          },
          {
            title: "投资者保护",
            url: "https://ir.p5w.net/c/002584.shtml",
            id: "3-4",
          },
          {
            title: "投资者互动平台",
            url: "./onLine.html",
            id: "3-5",
          },
          {
            title: "投资者联系方式",
            url: "./onLine.html",
            id: "3-6",
          },
        ],
      },
      {
        title: "新闻资讯",
        url: "./news.html",
        id: 4,
        list: [
          {
            title: "集团新闻",
            url: "./news.html?type=0",
            id: "4-1",
          },
          {
            title: "产品故事",
            url: "./news.html?type=1",
            id: "4-2",
          },
          {
            title: "视频中心",
            url: "./news.html?type=2",
            id: "4-3",
          },
          {
            title: "自有品牌",
            url: "./brand.html",
            id: "4-4",
          },
        ],
      },
      {
        title: "服务网络",
        url: "./service.html",
        id: 5,
        list: [],
      },
    ],
    dangerlicense: "危险品化学品经营许可证",
    businesslicense: "营业执照",
    contactUser: "联系方式：李经理  13544828089",
    address: "公司地址：广州市黄埔区新瑞路6号西陇创新园B栋一楼",
    company: "© Copyright 2020 夸泰克（广州）新材料有限责任公司",
  },
  home: {
    companyTitle: "公司介绍",
    companyDetail: "夸泰克公司位于广州，专注于高端电子化学品的研发、生产与服务，为集成电路制造提供最先进的电子材料解决方案。夸泰克拥有先进的生产、研发和配套检测设备，包括300毫米晶圆生产设备以及10级和100级洁净厂房，并采用MES系统进行管理，是世界上最先进的电子化学品生产和研发基地之一，为半导体行业提供具有最严格质量保证的超高纯度电子材料。",
    productTitle: "产品与服务",
    newsTitle: "最新资讯",
    moreBtn: "了解更多",
    customTitle: "客户群体",
    detail: "查看详情",
  },
  product: {
    breadcrumbs: {
      title: "产品中心",
      title1: "试剂",
      title2: "原料",
      title3: "日化",
      // title4: "大健康",
      // title5: "自有品牌",
      // title6: "互联网",
    },
  },
  news: {
    breadcrumbs: {
      title: "新闻资讯",
      title1: "集团新闻",
      title2: "产品故事",
      title3: "视频中心",
      title4: "自有品牌",
    },
    detail: "了解详情",
    pre: "上一页",
    next: "下一页",
  },
  aboutUs: {
    breadcrumbs: {
      title1: "关于西陇",
      title2: "企业简介",
      title3: "企业里程碑",
      title4: "实力影响",
      title5: "加入我们",
    },
    tab: {
      tab1: "企业简介",
      tab2: "企业里程碑",
      tab3: "实力影响",
      tab4: "加入我们",
    },
    introduce: "西陇简介",
    companyName: "西陇科学股份有限公司",
    companyContent: `西陇科学股份有限公司（简称“西陇科学”，股票代码：002584），原名西陇化工股份有限公司，创立于1983年，2011年在深圳证券交易所挂牌上市，是国内率先上市的化学试剂公司。公司为国家高新技术企业、国家级专精特新“小巨人”企业、省级制造业单项冠军示范企业（化学试剂）。</br>
    公司主要从事包括通用化学试剂、PCB用化学试剂、超净高纯化学试剂、湿电子化学品、原料药、食品添加剂、光伏电极材料、锂电材料等精细化学品和新材料的研发、生产、销售及配套服务。业务领域覆盖能源、石油石化、农业、卫生、环保、教学、科研、生物、生命科学、电子、军工、航天航空、涂料、印刷及化妆品、大医疗、大健康等领域。已发展成为国内技术领先的超大规模化学试剂专业制造商和集成供应商。</br>公司现有位于汕头、佛山、成都、昭通的大型生产基地，为客户就近提供便利的产品和服务。`,
    corporateCulture: "企业文化",
    culture: [
      {
        img: require("../assets/aem/yj.png"),
        img2: require("../assets/aem/yj2.png"),
        title: "愿景",
        intro: `通过精准的客户服务以及先进的平台，使我们的产品和服务涵盖新能源、生物医药等高端智造产业链的各个环节，成为领先的精细化学品和新材料的专业制造商与集成供应商`,
      },
      {
        img: require("../assets/aem/sm.png"),
        img2: require("../assets/aem/sm2.png"),
        title: "使命",
        intro: `科学助力幸福美好`,
      },
      {
        img: require("../assets/aem/jzg.png"),
        img2: require("../assets/aem/jzg2.png"),
        title: "价值观",
        intro: `激扬奋进 创新力行<br>诚信担当 合作共赢`,
      },
    ],
    chairman: "领导致辞",
    chaimanCon: `西陇科学事业的发展，始终依靠人才与科技，坚持管理创新；公司始终保持在研发能力、市场营销、品牌影响力的领先优势，
    做化学试剂行业中研发能力强、营销网络覆盖面广、品牌影响力巨大的专业制造商和集成供应商。`,
    honor: {
      professional: "专业团队",
      person: "名",
      technician: "技术人员",
      staff: "研发人员",
      master: "博士和硕士",
      teamIntroduction: `设立院士工作站和博士后科研工作站，聘请国内外院士、国内外著名大学和研究机构的教授、专家、学者作为公司技术顾问。通过引进海外特聘专家、杰出青年、“珠江人才计划”领军人才、“干人计划”人才和“扬帆计划”拔尖急缺人才等领先技术团队，
      引领公司的技术开发向国际化、规范化、高端化方向发展。`,
      honor: "荣誉资质",
      des: {
        one: "承担多项国家及省级科研项目，参加化学试剂国家标准及行业标准制定",
        two: "广东省精细化学品工程技术研究开发中心",
        three: "广东省产学研混合示范基地及精细化学品研发基地",
        four: "广东省企业技术中心/ 博士后工作站/ 院士工作站",
      },
      item1: {
        one: "国家火炬计划项目",
        two: "星火计划项目",
        three: "重点新产品项目15项",
      },
      item2: {
        one: "省级火炬计划项目",
        two: "重点新产品项目48项",
      },
      item3: {
        one: "公司及子公司拥有自主知识产权的专利379项",
        two: "其中发明专利49项",
      },
      item4: {
        one: "省部级以上科技、",
        two: "创新、技改项目112项",
      },
    },
    joinUs: {
      recruitment: "招聘中心",
      tableHeade: [
        { name: "招聘部门", id: 0 },
        { name: "职位", id: 1 },
        { name: "工作地点", id: 2 },
        { name: "发布日期", id: 3 },
        { name: "职位申请", id: 4 },
      ],
      detail: "查看详情",
      detailTab: {
        location: "工作地点",
        age: "年龄",
        benefits: "薪资待遇",
        date: "发布日期",
        experience: "工作经验",
        education: "学历",
        num: "招聘人数",
        validity: "职位有效期",
      },
      responsibility: "岗位职责",
      apply: "立即申请",
    },
  },
  network: {
    serviceNet: "服务网络",
    companyName: "西陇科学股份有限公司",
    address: "地址：广东省汕头市潮汕路西陇中街1-3号",
    telphone: "电话：0754-82481166",
    zipcode: "邮编：515000",
    office: [
      {
        id: 1,
        list: [
          { name: "汕头基地", tel: "0754-8249 3143", id: "1-1" },
          { name: "广州公司", tel: "020-6261 2188(382)", id: "1-2" },
          { name: "四川公司", tel: "028-8543 1583", id: "1-3" },
          { name: "上海公司", tel: "021-5290 7766", id: "1-4" },
          { name: "沈阳公司", tel: "024-6226 5178", id: "1-5" },
          { name: "国际部", tel: "020-6261 2188", id: "1-6" },
          { name: "中山办", tel: "0760-8861 2703", id: "1-7" },
        ],
      },
      {
        id: 2,
        list: [
          { name: "北京办", tel: "010-5979 6198", id: "2-1" },
          { name: "天津办", tel: "022-2498 0521", id: "2-2" },
          { name: "青岛办", tel: "0532-8097 1508", id: "2-3" },
          { name: "济南办", tel: "0531-6880 3970", id: "2-4" },
          { name: "郑州办", tel: "0371-6030 6707", id: "2-5" },
          { name: "太原/内蒙办", tel: "0351-3336 609", id: "2-6" },
          { name: "佛山办", tel: "0757-6689 1888", id: "2-7" },
        ],
      },
      {
        id: 3,
        list: [
          { name: "西安办", tel: "029-8822 7067", id: "3-1" },
          { name: "南京办", tel: "025-8777 0804", id: "3-2" },
          { name: "苏州办", tel: "0512-6568 1359", id: "3-3" },
          { name: "合肥办", tel: "0551-6560 4179", id: "3-4" },
          { name: "武汉办", tel: "027-6560 3032", id: "3-5" },
          { name: "石家庄办", tel: "0311-8980 6988", id: "3-6" },
          { name: "东莞办", tel: "0769-8537 9892", id: "3-7" },
        ],
      },
      {
        id: 4,
        list: [
          { name: "重庆办", tel: "023-6871 4273", id: "4-1" },
          { name: "湖南办", tel: "0731-8555 5842", id: "4-2" },
          { name: "江西办", tel: "0791-8620 0012", id: "4-3" },
          { name: "宁波办", tel: "0574-5501 9950", id: "4-4" },
          { name: "杭州办", tel: "0571-8783 0782", id: "4-5" },
          { name: "无锡办", tel: "0510-8877 2476", id: "4-6" },
          { name: "惠州办", tel: "0752-2555 053", id: "4-7" },
        ],
      },
      {
        id: 5,
        list: [
          { name: "福州办", tel: "0591-8353 8269", id: "5-1" },
          { name: "厦门办", tel: "0592-8069 292", id: "5-2" },
          { name: "贵州办", tel: "0771-2627 323", id: "5-3" },
          { name: "昆明办", tel: "0871-6355 9897", id: "5-4" },
          { name: "南宁办", tel: "0771-2627 323", id: "5-5" },
          { name: "南通办", tel: "0513-8555 9006", id: "5-6" },
          { name: "海南办", tel: "0898-6683 3422", id: "5-7" },
        ],
      },
    ],
    searchTab: {
      title1: "COA搜索",
      title2: "MSDS搜索",
      title3: "安全标签搜索",
      title4: "TDS搜索",
    },
  },
  contact: {
    title: "联系我们",
    contract: "联系人",
    contractPhone: "联系电话",
    companyName: "公司名称",
    email: "电子邮箱",
    consultQuestion: "咨询问题",
    btns: {
      reset: "重置",
      submit: "提交",
    },
    cons: {
      title: "联系方式",
      companyName: "西陇科学股份有限公司",
      address: "地址",
      addressDetail: "广州市黄埔区科学城新瑞路6号",
      tel: "联系电话",
      telPhone: "020-62612188",
    },
  },
  search: {
    tabHeader: [
      { name: "品类名称", id: 1 },
      { name: "生效日期", id: 2 },
      { name: "批次号", id: 3 },
      { name: "CAS号", id: 4 },
      { name: "描述", id: 5 },
      { name: "操作", id: 6 },
    ],
    detail: "查看详情",
  },
  document: {
    search: "高级搜索",
    inspect: "如何获取质检证书(COA)?",
    enter: "请输入存货名称和一个与之匹配的批号和验证码",
    title: "请输入存货名称",
    batchNo: "请输入批次号前6位数字",
    cas: "请输入cas号",
    code: "请输入验证码",
  },
};
